module.exports = __webpack_public_path__ + "img/placeholder.82ab14f7.png";